import axios from 'axios';
import { call } from 'redux-saga/effects';
import { GET_MOVIES_BY_CINEMA_ENDPOINT, GET_ALL_MOVIES_ON_SCHEDULE_ENDPOINT, GET_MOVIES_BY_CINEMA_ID_ENDPOINT, GET_MOVIE_THEATER_DETAILS_ENDPOINT } from '../config/apiEndpoints';
import { getTokenHeaders as tokenHeader } from '../helpers/api.helper';

export function* getMoviesByCinemaApi(payload) {
    const header = tokenHeader();

    let api_url_dynamic = GET_MOVIES_BY_CINEMA_ENDPOINT.replace('date', payload.date);

    let URL = api_url_dynamic;
    if (payload) {
        URL = api_url_dynamic + '&cinema_address_locality=' + payload.selectedCinemaLocation
    }
    return yield call(axios.get, URL, header);
}

export function* getMoviesByCinemaIdApi(payload) {
    const header = tokenHeader();
    let params = payload;

    if (payload) {
        params = {
            cinema_address_locality: payload.selectedCinemaLocation
        };
    }

    let api_url_dynamic = GET_MOVIES_BY_CINEMA_ID_ENDPOINT.replace('date', payload.date);
    api_url_dynamic = api_url_dynamic.replace('id', payload.id);
    return yield call(axios.get, api_url_dynamic, { params }, { header });
}

export function* getMovieTheaterDetails(payload) {
    const header = tokenHeader();
    let url = GET_MOVIE_THEATER_DETAILS_ENDPOINT + payload + '?_format=api_json';
    return yield call(axios.get, url, header);
}

export function* getAllMoviesForSchedule(payload) {
    const header = tokenHeader();

    let api_url_dynamic = GET_ALL_MOVIES_ON_SCHEDULE_ENDPOINT.replace('date', payload.date) + `&` + "cinema_address_locality=" + localStorage.getItem("cinema_location");
    return yield call(axios.get, api_url_dynamic, header);
}





// WEBPACK FOOTER //
// ./src/SHARED/api/schedule.api.js